'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Cover from '../../cover'
import Text, { TextProps } from '../../text'

/* -----------------------------------------------------------------------------
 * FieldPlaceholder
 * -------------------------------------------------------------------------- */

export type FieldPlaceholderProps = TextProps & {
  children: React.ReactNode
}

const FieldPlaceholder = (props: FieldPlaceholderProps) => {
  const paddingTop = 29

  return (
    <Cover pointerEvents='none'>
      <Text
        p='12'
        pt={paddingTop as any}
        font='text.15.medium'
        textColor='coolGray'
        {...props}
      />
    </Cover>
  )
}

export default FieldPlaceholder
